<template>
	<sa-page-layout :btnSaveVisible="false" :btnAnnullaVisible="false" :linkback="linkback" :showModalLoading="showModalLoading" class="sa-no-space">
		<template slot="table-body">
			<data-analisys-pivot-view-component></data-analisys-pivot-view-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DataAnalisysPivotViewComponent from "../components/DataAnalisysPivotViewComponent.vue";
export default {
	components: { SaPageLayout, DataAnalisysPivotViewComponent },
	data() {
		return {
			linkback: null,
			showModalLoading: false,
		};
	},
};
</script>

<style></style>
